import {Injectable} from '@angular/core';
import {BaseMonitoringDao} from '../../../../base-monitoring-dao';
import {UserUsage} from '../../../../models-monitoring';
import {KluhManagerValidator} from '../../../../validators/kluh-manager-validator';
import {Observable} from 'rxjs/internal/Observable';
import {R2CloudHttpMonitoringService} from '../../../../r2-cloud-http-monitoring.service';

@Injectable({
    providedIn: 'root'
})
export class UserDetailsTableDaoService extends BaseMonitoringDao<UserUsage> {
    constructor(http: R2CloudHttpMonitoringService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'user-usage');
    }

    findAllByClientId(desktopServerClientId: string): Observable<UserUsage[]> {
        return this.http.get<UserUsage[]>(this.url + '/find-all-by-client-id/' + desktopServerClientId);
    }
}
